// ** Initial State
const initialState = {
  allData: [],
  data: [],
  pricingData: [],
  amount: [],
  allExhibitors: []
}

const bookingnew3 = (state = initialState, action) => {
  switch (action.type) {
    case 'BOOKING_LIST':
      return { ...state, allData: action.data}
    case 'CREATE_BOOKING':
      return { ...state, data: action.data}
    case 'BOOKINGREF':
      return { ...state, data: action.data }
    case 'CREATE_SURVEY':
      return { ...state, data: action.data }
    case 'CREATE_MEETING':
      return { ...state, data: action.data }
    case 'CREATE_PAYMENT':  
      return { ...state, data: action.data }
    case 'PRICING_LIST':
      return { ...state, pricingData: action.data }
    case 'CHECKAMOUNT':
      return { ...state, amount: action.data }
    case 'GET_ALL_EXHIBITORS':
      return { ...state, allExhibitors: action.data }
    default:
      return { ...state }
  }
}
export default bookingnew3
